import React from "react";
import TRC_Logo from "../../assets/TRC_Small.svg";
import Fantasy from "../../assets/Fantasy_Small.svg";
import { Image } from "react-bootstrap";

const SmallLogo: React.FC = () => {
	return (
		<div className="d-flex flex-row justify-content-start">
			<Image
				src={TRC_Logo}
				alt="TRC Logo"
				style={{ height: "1.3rem", marginRight: "10px" }}
			/>
			<Image
				src={Fantasy}
				alt="Fantasy Logo"
				style={{ height: "1.4rem", marginRight: "10px" }}
			/>
		</div>
	);
};

export default SmallLogo;
